import axios from "axios"

// The gateway answers 404 when the account has no Move With Us record.
export const isMoveWithUsNotFound = (error: unknown) =>
  axios.isAxiosError(error) && error.response?.status === 404
